import { SITE_TYPE } from 'pages/settings/sections/sites/types';
import { APIS, isNewBackend } from 'config';
class SingletonConfig {
  constructor() {
    this.isSingleSite = false;
  }

  syncMasterSlave(masterSlave) {
    if (isNewBackend) {
      const loggedClient = masterSlave?.SlaveDetails?.find(s => s.DbTenantId === masterSlave.CurrentSiteGuid);
      this.isSingleSite = loggedClient ? loggedClient?.SiteType === SITE_TYPE.SITE : false;
    } else {
      this.isSingleSite = !!masterSlave?.CurrentyLoggedClient;
    }
  }

  get isGlobalMode() {
    if (!this.isSingleSite) {
      // onPrem isSingleSite return false (CurrentyLoggedClient = '') but isGlobalMode return false because we are in single site page.
      //This is the regex to check if we are in global page (we can't count on isSingleSite because it's async call we need to change that it's will be the first api call and then we won't need to check this regex).
      const regex = /\/GlobalManage\/(Forensic|Alerts|Audit|[Ss]ettings|default)/;
      const currentLink = window.location.href;
      if (this.lastLink !== currentLink) {
        this.regexResult = regex.test(currentLink);
      }
      this.lastLink = currentLink;

      return this.regexResult;
    }

    return false;
  }

  get baseControllerPath() {
    return this.isGlobalMode ? APIS.GLOBAL : APIS.APP;
  }
}

export default new SingletonConfig();
